const request = ({
  url,
  jsonHandler,
  body,
  clearInterval,
  errorHandler,
}) => {
  fetch(`/api/${url}`, {
    credentials: 'include',
    ...body && {
      body: JSON.stringify(body),
      method: 'post',
    },
    headers: { 'Content-Type': 'application/json' },
  }).then(response => {
    if (!response.ok) {
      let msg;

      if (response.status === 401) {
        msg = 'Please log in.';
      } else if (response.status === 403) {
        msg = 'This module is not enabled.';
        clearInterval();
      } else {
        msg = 'An error has occurred.';
        clearInterval();
      }

      throw Error(msg);
    } else if (response.status !== 204) {
      return response.json();
    }

    return null;
  }).then(jsonHandler)
    .catch(error => errorHandler(error));
};

export default request;



// WEBPACK FOOTER //
// ./src/api/request.js